// ==========================================
// SAPUNA FLORAL CHARM EXFOLIATING BODY SCRUB
// Full Shopify integration with auto-sync, add to cart, upsells, and quantity selector
// ==========================================

(function() {
  'use strict';
  
  // ==========================================
  // PRODUCT CONFIGURATION
  // ==========================================
  const mainProductHandle = 'floral-charm-exfoliating-body-scrub';
  const mainVariantId = 45861444386952;
  const whatsappNumber = '96170065685';
  const productTitle = 'Floral Charm Exfoliating Body Scrub';
  const productImage = 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/floralcharmbodyscrub_d437a8a8-0d04-4705-b87f-54e95b0b72ca.jpg?v=1779470394';
  
  // Upsell products configuration
  const upsellConfigs = [
    {
      variantId: 45861438718088,
      handle: 'floral-charm-hydrating-body-lotion',
      priceElementId: 'upsell-price-1',
      title: 'Floral Charm Hydrating Body Lotion',
      image: 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/floralcharmbodylotionsapunacopy3_0b4e571f-d597-420d-beb3-4c23910bad61.jpg?v=1779470393'
    },
    {
      variantId: 45861441470600,
      handle: 'strawberry-passion-hydrating-body-lotion',
      priceElementId: 'upsell-price-2',
      title: 'Strawberry Passion Hydrating Body Lotion',
      image: 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/strawberrypassionbodylotionsapunacopy3_47da7083-fb8e-46af-b77c-ce8abbc622cf.jpg?v=1779470394'
    }
  ];
  
  // State variables
  let quantity = 1;
  let currentVariantId = mainVariantId;
  let currentPrice = 24.90;
  let currentComparePrice = 39.90;
  let isInStock = true;
  let isSyncing = false;
  let upsellData = {};
  
  // DOM elements
  const quantitySpan = document.getElementById('sapuna-quantity');
  const minusBtn = document.getElementById('sapuna-qty-minus');
  const plusBtn = document.getElementById('sapuna-qty-plus');
  const addToCartBtn = document.getElementById('sapuna-add-to-cart');
  const successMsg = document.getElementById('sapuna-cart-success');
  const mainPriceEl = document.getElementById('sapuna-main-price');
  const comparePriceEl = document.getElementById('sapuna-compare-price');
  const saveBadgeEl = document.getElementById('sapuna-save-badge');
  const whatsappBtn = document.querySelector('.sapuna-whatsapp-btn');
  
  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function formatMoney(amount) {
    if (typeof amount !== 'number' || isNaN(amount)) return '$0.00';
    return `$${amount.toFixed(2)}`;
  }
  
  function updateSaveBadge(price, comparePrice) {
    if (saveBadgeEl && comparePrice && comparePrice > price) {
      const saved = comparePrice - price;
      saveBadgeEl.textContent = `SAVE $${Math.round(saved)}`;
      saveBadgeEl.style.display = '';
    } else if (saveBadgeEl) {
      saveBadgeEl.style.display = 'none';
    }
  }
  
  function showMessage(message, isError = false) {
    if (!successMsg) return;
    successMsg.textContent = message;
    successMsg.style.color = isError ? '#dc3545' : '#57ADAE';
    successMsg.classList.add('show');
    setTimeout(() => {
      successMsg.classList.remove('show');
    }, 2000);
  }
  
  function updateWhatsAppLink() {
    if (!whatsappBtn) return;
    const stockText = isInStock ? 'In stock' : 'Sold out';
    const msg = encodeURIComponent(`Hello, I'm interested in ${productTitle} for ${formatMoney(currentPrice)}. ${stockText}`);
    whatsappBtn.href = `https://wa.me/${whatsappNumber}?text=${msg}`;
  }
  
  function updateAddToCartButton() {
    if (!addToCartBtn) return;
    if (!isInStock) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart →';
    }
  }
  
  // ==========================================
  // SHOPIFY CART FUNCTIONS
  // ==========================================
  async function addToCart(variantId, title, price, image, handle, qty = null) {
    const quantityToAdd = qty !== null ? qty : quantity;
    
    try {
      if (typeof window.addProductToCart === 'function') {
        window.addProductToCart({
          title: title,
          variant: null,
          price: price,
          compareAtPrice: null,
          variantId: variantId,
          quantity: quantityToAdd,
          image: image,
          handle: handle,
          available: true
        });
      } else if (typeof window.addToCart === 'function') {
        await window.addToCart({ variantId: variantId, quantity: quantityToAdd, title: title, image: image, handle: handle });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantityToAdd
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData && errorData.description ? errorData.description : 'Failed to add to cart');
        }
        
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      return true;
    } catch (error) {
      console.error('Add to cart error:', error);
      throw error;
    }
  }
  
  async function handleMainAddToCart() {
    if (!isInStock) {
      showMessage('This product is out of stock!', true);
      return;
    }
    
    if (!addToCartBtn) return;
    
    const originalText = addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';
    
    try {
      await addToCart(
        currentVariantId,
        productTitle,
        currentPrice,
        productImage,
        mainProductHandle,
        quantity
      );
      
      showMessage(`✓ Added ${quantity} item(s) to cart!`);
    } catch (error) {
      showMessage(error.message || 'Error adding to cart', true);
    }
    
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = originalText;
    updateAddToCartButton();
  }
  
  async function handleUpsellAddToCart(event, btn, variantId) {
    event.stopPropagation();
    event.preventDefault();
    
    const upsellProduct = upsellData[variantId];
    if (!upsellProduct) {
      console.error('Upsell product data not found');
      return;
    }
    
    if (!upsellProduct.inStock) {
      showMessage(`${upsellProduct.title} is out of stock!`, true);
      return;
    }
    
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    
    try {
      await addToCart(
        variantId,
        upsellProduct.title,
        upsellProduct.price,
        upsellProduct.image,
        upsellProduct.handle,
        1
      );
      
      showMessage(`${upsellProduct.title} added to cart!`);
    } catch (error) {
      showMessage(error.message || 'Error adding to cart', true);
    }
    
    btn.disabled = false;
    btn.textContent = originalText;
  }
  
  // ==========================================
  // SHOPIFY DATA SYNC
  // ==========================================
  async function syncMainProductData() {
    if (isSyncing) return;
    isSyncing = true;
    
    try {
      const response = await fetch(`/products/${mainProductHandle}.js`);
      if (!response.ok) throw new Error(`Failed to load product: ${mainProductHandle}`);
      
      const product = await response.json();
      const variant = product.variants.find(v => v.id === currentVariantId);
      
      if (variant) {
        currentPrice = variant.price / 100;
        currentComparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
        isInStock = variant.available;
        
        if (mainPriceEl) mainPriceEl.textContent = formatMoney(currentPrice);
        
        if (comparePriceEl && currentComparePrice && currentComparePrice > currentPrice) {
          comparePriceEl.textContent = formatMoney(currentComparePrice);
          comparePriceEl.style.display = '';
        } else if (comparePriceEl) {
          comparePriceEl.style.display = 'none';
        }
        
        updateSaveBadge(currentPrice, currentComparePrice);
        updateAddToCartButton();
        updateWhatsAppLink();
      }
    } catch (error) {
      console.error('Failed to sync main product data:', error);
    } finally {
      isSyncing = false;
    }
  }
  
  async function syncUpsellProduct(upsellConfig) {
    try {
      const response = await fetch(`/products/${upsellConfig.handle}.js`);
      if (!response.ok) throw new Error(`Failed to load upsell: ${upsellConfig.handle}`);
      
      const product = await response.json();
      const variant = product.variants.find(v => v.id === upsellConfig.variantId);
      
      if (variant) {
        const price = variant.price / 100;
        const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
        const inStock = variant.available;
        
        upsellData[upsellConfig.variantId] = {
          title: product.title || upsellConfig.title,
          price: price,
          comparePrice: comparePrice,
          inStock: inStock,
          image: product.featured_image || upsellConfig.image,
          handle: upsellConfig.handle
        };
        
        const priceElement = document.getElementById(upsellConfig.priceElementId);
        if (priceElement) priceElement.textContent = formatMoney(price);
        
        const card = document.querySelector(`.sapuna-upsell-card[data-upsell-variant-id="${upsellConfig.variantId}"]`);
        const addBtn = card ? card.querySelector('.sapuna-upsell-add-btn') : null;
        
        if (addBtn) {
          if (!inStock) {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
        }
      }
    } catch (error) {
      console.error(`Failed to sync upsell product ${upsellConfig.handle}:`, error);
    }
  }
  
  async function syncAllUpsellProducts() {
    for (const config of upsellConfigs) {
      await syncUpsellProduct(config);
    }
  }
  
  // ==========================================
  // QUANTITY CONTROLS
  // ==========================================
  if (minusBtn) {
    minusBtn.addEventListener('click', function() {
      if (quantity > 1) {
        quantity--;
        if (quantitySpan) quantitySpan.textContent = quantity;
      }
    });
  }
  
  if (plusBtn) {
    plusBtn.addEventListener('click', function() {
      quantity++;
      if (quantitySpan) quantitySpan.textContent = quantity;
    });
  }
  
  // ==========================================
  // BUTTON EVENT LISTENERS
  // ==========================================
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleMainAddToCart);
  }
  
  // Upsell buttons
  document.querySelectorAll('.sapuna-upsell-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      const variantId = parseInt(btn.getAttribute('data-variant-id'));
      handleUpsellAddToCart(e, btn, variantId);
    });
  });
  
  // Review link scroll
  const reviewLink = document.querySelector('.sapuna-review-count');
  if (reviewLink) {
    reviewLink.addEventListener('click', function() {
      const reviewsSection = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');
      if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }
  
  // ==========================================
  // COLLAPSIBLES / ACCORDIONS
  // ==========================================
  document.querySelectorAll('.sapuna-collapsible').forEach(function(coll) {
    const header = coll.querySelector('.sapuna-collapsible-header');
    const content = coll.querySelector('.sapuna-collapsible-content');
    const icon = header ? header.querySelector('.sapuna-collapsible-icon') : null;
    
    if (header && content) {
      header.addEventListener('click', function() {
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        if (icon) {
          icon.textContent = isOpen ? '+' : '−';
        }
      });
    }
  });
  
  // ==========================================
  // INITIALIZATION
  // ==========================================
  syncMainProductData();
  syncAllUpsellProducts();
  
  // Auto-sync every 5 minutes
  setInterval(syncMainProductData, 300000);
  setInterval(syncAllUpsellProducts, 300000);
  
  console.log('Sapuna Floral Charm Exfoliating Body Scrub - Product section initialized');
})();